enum UserTypology {
    System = "System",
    Simec = "Simec",
    Customer = "Customer"
}

export default UserTypology;